module.exports = __webpack_public_path__ + "img/austria-other-heart-diseases-male.43b063d4.png";